import React from "react";
import { connect } from "react-redux";
import axios from "axios";
import routes from "../../../assets/apiRoutes.json"
import { Button } from "devextreme-react/button";
import Toolbar, { Item } from "devextreme-react/toolbar";
import { LoadIndicator } from "devextreme-react/load-indicator";
import { createStore } from "devextreme-aspnet-data-nojquery";
import { Lookup as LookupBox, DropDownOptions } from "devextreme-react/lookup";
import { downloadReportFile } from "../../../common/Utils";

let accessToken = "";
const productionLotSelectBox = React.createRef();

class BagTags extends React.Component {
  constructor(props) {
    super(props);

    accessToken = props.oidc.user.access_token;

    this.state = {
      loadIndicatorVisible: false,
      productionlot: ""
    };

    this.previewButtonClicked = this.previewButtonClicked.bind(this);
    this.resetButtonClicked = this.resetButtonClicked.bind(this);
    this.productionLotChanged = this.productionLotChanged.bind(this);

    this.productionLotDataSource = createStore({
      loadUrl: `${window._env_.REACT_APP_APIS}/${routes.master_records.GetProductionLots}`,
      onBeforeSend: function(method, ajaxOptions) {
        ajaxOptions.headers = {
          Authorization: `Bearer ${accessToken}`
        };
      }
    });

  }

  render() {
    return (
      <div style={{ marginBottom: "10px" }}>
                <div className="title">
                        <h6
                          style={{
                            color: window._env_.Color2
                          }}
                        >
                          Bag Tags Report
                        </h6>
                      </div>
        <Toolbar style={{ backgroundColor: "rgb(240, 241, 239)" }}>
          <Item location="before">
            <LookupBox
                ref={productionLotSelectBox}
                placeholder="Production Lot"
                dataSource={this.productionLotDataSource}
                valueExpr="prodlot"
                displayExpr="bareRootPickList"
                onValueChanged={this.productionLotChanged}
                searchEnabled={true}
                showClearButton={true}
                width={300}
            >
              <DropDownOptions hideOnOutsideClick={true} width={500} />
            </LookupBox>
          </Item>
          <Item location="before">
            <Button
              text="Reset"
              type="default"
              onClick={this.resetButtonClicked}
            />
          </Item>
          <Item location="before">
            <Button type="default" onClick={this.previewButtonClicked}>
              <LoadIndicator
                style={{
                  height: "20px",
                  width: "20px",
                  verticalAlign: "middle",
                  marginRight: "5px",
                }}
                visible={this.state.loadIndicatorVisible}
              />
              <span className="dx-button-text">Preview</span>
            </Button>
          </Item>
        </Toolbar>
      </div>
    );
  }

  productionLotChanged(e) {
    this.setState({
      productionlot: e.value,
    });

  }

  resetButtonClicked() {
    this.setState({
      productionlot: ""
    });
    productionLotSelectBox.current.instance().reset();
  }
  previewButtonClicked() {
    this.setState({
      loadIndicatorVisible: true
    });

    var that = this;
    var request = new Object();
    request.productionlot = this.state.productionlot;
    axios.post
    (
        `${window._env_.REACT_APP_APIS}/${routes.master_records.GenerateBagTagsReport}`, request,
        {
            headers: {
                "Content-Type": "application/json",
                access_token: accessToken,
            },
        }
    )
    .then((res) => {
      if (res.data.isSuccess) 
      {
        // Returned so the loader stays up until the file has downloaded.
        return downloadReportFile(res.data.fileName, accessToken);
      }

    })
    .catch((err) => {
        alert(err, "Error");
    })
    .finally(() => {
      this.setState({
        loadIndicatorVisible: false,
      });
    });
  }
}

function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}

export default connect(mapStateToProps)(BagTags);
